<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>后台帐号管理</p>
          <div class="btnBox" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('3-1')>-1">
            <button class="btn btn-add" @click="addShow">添加账号</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.level_name">{{item.level_name}}</p>
              <p :title="item.update_time">{{item.update_time}}</p>
              <p style="color:#457AFF;" @click="editShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('3-2')>-1">修改信息</p>
              <p style="color:#FF7543;" @click="authorityShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('3-3')>-1">权限配置</p>
              <p style="color:#FF5156;" @click="removeShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('3-4')>-1">注销账号</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加提示框 -->
    <div class="msgBox tipsBox addBox" v-if="addType">
      <div class="contv">
        <p class="title">{{addType=='add'?'添加账号':'修改账号'}}</p>
        <form>
          <div class="write-txt">
            <p>用户名：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>手机号：</p>
            <input type="number" v-model="addObj.mobile" @input="numCheck(addObj.mobile,11,'mobile')">
          </div>
          <div class="write-txt">
            <p>角色：</p>
            <select v-model="addObj.lid">
              <option value="">请选择角色</option>
              <option :value="item.id" v-for="item in userList" v-bind:key="item.id">{{item.level_name}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">添加</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <!-- 权限配置提示框 -->
    <div class="msgBox tipsBox authorityBox " v-if="authorityType">
      <div class="contv">
        <p class="title">权限配置</p>
        <div class="list">
          <div class="first" v-for="item in authorityList" v-bind:key="item.id">
            <p class="first-title">{{item.title}}</p>
            <div class="second">
              <div class="second-title" v-for="ele in item.children" v-bind:key="ele.id" :class="ele.disabled?'noPointer':''">
                <label>
                  <input type="checkbox" v-model="ele.check" :value="ele.id" :disabled="ele.disabled">
                  <p>{{ele.title}}</p>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-sub" @click="authoritySub">添加</button>
          <button class="btn btn-close" @click="authorityType=false;">取消</button>
        </div>
      </div>
    </div>

    <!-- <div class="msgBox tipsBox authorityBox" v-if="authorityType">
      <div class="contv">
        <p class="title">权限配置</p>
        <AuthorityList :list="list"></AuthorityList>
        <div class="btnBox">
          <button class="btn btn-sub" @click="authoritySub">添加</button>
          <button class="btn btn-close" @click="authorityType=false;">取消</button>
        </div>
      </div>
    </div> -->

    <!-- 注销提示框 -->
    <div class="msgBox removeBox" v-if="removeType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认注销此账号吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeSub">删除</button>
          <button class="btn btn-close" @click="removeHide">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import AuthorityList from './../components/comment/AuthorityList.vue';
import { addManage ,getLevelList,getManageList,updateManage,delManage,getManageAuthority,setManageAuthority } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'5',
      childrenID:'5-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'用户ID'},
        {id:3,title:'用户名'},
        {id:4,title:'手机号'},
        {id:5,title:'角色'},
        {id:6,title:'更新时间'},
      ],
      dataList:[],
      currentPage1: 2,
      removeType:false,
      topicType:[
        {id:1,title:'单选题'},
        {id:2,title:'多选题'},
        {id:3,title:'判断题'},
      ],
      showType:'list',
      addType:'',
      authorityType:false,
      authorityList:[
        {id:'1-1',title:'证书类型设置',children:[
            {id:'1-1-1',title:'添加类型',check:false,disabled:true},
            {id:'1-1-2',title:'编辑类型',check:false,disabled:true},
          ]
        },
        {id:'1-2',title:'证书列表',children:[
            {id:'1-2-1',title:'添加证书',check:false,disabled:true},
            {id:'1-2-2',title:'查看题库',check:false,disabled:true},
            {id:'1-2-3',title:'查看学员',check:false,disabled:true},
            {id:'1-2-4',title:'配置',check:false,disabled:true},
            {id:'1-2-5',title:'编辑证书',check:false,disabled:true},
            {id:'1-2-6',title:'发布',check:false,disabled:true},
          ]
        },
        {id:2,title:'学员管理',children:[
          {id:'2-1',title:'导入学员/添加学员',check:false,disabled:true},
          {id:'2-2',title:'编辑学员',check:false,disabled:true},
          {id:'2-3',title:'注销学员',check:false,disabled:true},
        ]},
        {id:3,title:'后台账号管理',children:[
          {id:'3-1',title:'添加账号',check:false,disabled:true},
          {id:'3-2',title:'修改信息',check:false,disabled:true},
          {id:'3-3',title:'权限配置',check:false,disabled:true},
          {id:'3-4',title:'注销账号',check:false,disabled:true},
        ]},
        {id:4,title:'角色管理',children:[
          {id:'4-1',title:'新增角色',check:false,disabled:true},
          {id:'4-2',title:'权限配置',check:false,disabled:true},
          {id:'4-3',title:'删除账号',check:false,disabled:true},
        ]},
        {id:5,title:'题型配置',children:[
          {id:'5-1',title:'编辑题型',check:false,disabled:true},
        ]},
      ],
      token:'',
      addObj:{
        mobile:'',
        name:'',
        lid:''
      },
      obj:{
        page:1,
        rows:10
      },
      userList:[],
      userid:'',
      totalPage:0,
      list: [
        {
          id:1,title:"证书管理",children:[
            {
              id:'1-1',title:'证书类型设置',children:[
                {id:'1-1-1',title:'添加类型',check:false,disabled:true},
                {id:'1-1-2',title:'编辑类型',check:false,disabled:true},
              ]
            },
            {
              id:'1-2',title:'证书列表',children:[
                {id:'1-1',title:'添加证书',check:false,disabled:true},
                {id:'1-2',title:'查看题库',check:false,disabled:true},
                {id:'1-3',title:'查看学员',check:false,disabled:true},
                {id:'1-4',title:'配置',check:false,disabled:true},
                {id:'1-5',title:'编辑证书',check:false,disabled:true},
                {id:'1-6',title:'发布',check:false,disabled:true},
              ]
            },
          ]
        },
        {id:2,title:'学员管理',children:[
          {id:'2-1',title:'导入学员/添加学员',check:false,disabled:true},
          {id:'2-2',title:'编辑学员',check:false,disabled:true},
          {id:'2-3',title:'注销学员',check:false,disabled:true},
        ]},
        {id:3,title:'后台账号管理',children:[
          {id:'3-1',title:'添加账号',check:false,disabled:true},
          {id:'3-2',title:'修改信息',check:false,disabled:true},
          {id:'3-3',title:'权限配置',check:false,disabled:true},
          {id:'3-4',title:'注销账号',check:false,disabled:true},
        ]},
        {id:4,title:'角色管理',children:[
          {id:'4-1',title:'新增角色',check:false,disabled:true},
          {id:'4-2',title:'权限配置',check:false,disabled:true},
          {id:'4-3',title:'删除账号',check:false,disabled:true},
        ]},
        {id:5,title:'题型配置',children:[
          {id:'5-1',title:'编辑题型',check:false,disabled:true},
        ]},
      ],
      userData:{
        authority:[],
      },
    };
  },
  components: {
    navBox,
    myHeader,
    AuthorityList
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.getList();
    this.getUser();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    addShow(){
      this.addType = 'add';
    },

    addSub(){
      var that = this;
      var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i;
      if(that.addObj.name == ''){
        that.$message('请输入用户名！');
        return false;
      };
      if(this.addObj.mobile === '' || !regex.test(this.addObj.mobile)){
        that.$message('请输入正确的手机号码！');
        return false;
      };
      if(this.addObj.lid == ''){
        that.$message('请选择角色！');
        return false;
      };
      if(this.addType == 'add'){
        that.addObj.type = '3-1';
        addManage(that.addObj,that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('添加成功！');
            that.resetSub();
            that.addType = '';
          } else {
            that.$message(data.msg);
          }
        })
      } else {
        that.addObj.type = '3-2';
        updateManage(that.addObj,that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('修改成功！');
            that.resetSub();
            that.addType = '';
          } else {
            that.$message(data.msg);
          }
        })
      }
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10
      };
      this.dataList = [];
      this.addObj = {
        name:'',
        mobile:'',
        lid:""
      };
      this.authorityList=[
        {id:'1-1',title:'证书类型设置',children:[
            {id:'1-1-1',title:'添加类型',check:false,disabled:true},
            {id:'1-1-2',title:'编辑类型',check:false,disabled:true},
          ]
        },
        {id:'1-2',title:'证书列表',children:[
            {id:'1-1',title:'添加证书',check:false,disabled:true},
            {id:'1-2',title:'查看题库',check:false,disabled:true},
            {id:'1-3',title:'查看学员',check:false,disabled:true},
            {id:'1-4',title:'配置',check:false,disabled:true},
            {id:'1-5',title:'编辑证书',check:false,disabled:true},
            {id:'1-6',title:'发布',check:false,disabled:true},
          ]
        },
        {id:2,title:'学员管理',children:[
          {id:'2-1',title:'导入学员/添加学员',check:false,disabled:true},
          {id:'2-2',title:'编辑学员',check:false,disabled:true},
          {id:'2-3',title:'注销学员',check:false,disabled:true},
        ]},
        {id:3,title:'后台账号管理',children:[
          {id:'3-1',title:'添加账号',check:false,disabled:true},
          {id:'3-2',title:'修改信息',check:false,disabled:true},
          {id:'3-3',title:'权限配置',check:false,disabled:true},
          {id:'3-4',title:'注销账号',check:false,disabled:true},
        ]},
        {id:4,title:'角色管理',children:[
          {id:'4-1',title:'新增角色',check:false,disabled:true},
          {id:'4-2',title:'权限配置',check:false,disabled:true},
          {id:'4-3',title:'删除账号',check:false,disabled:true},
        ]},
        {id:5,title:'题型配置',children:[
          {id:'5-1',title:'编辑题型',check:false,disabled:true},
        ]},
      ];
      this.getList();
    },

    getUser(){
      var that = this;
      getLevelList(that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.userList = data.data;
        } else {
          that.$message(data.msg);
        }
      })
    },

    getList(){
      var that = this;
      getManageList(that.obj,that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.addObj.mobile = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },

    closeSub(){
      this.addObj = {
        name:'',
        mobile:'',
        lid:""
      };
      this.addType='';
    },

    editShow(e){
      this.addObj = {
        mobile:e.mobile,
        name:e.name,
        lid:e.lid,
        id:e.id
      };
      this.addType='edit';
    },

    removeShow(e){
      this.removeType = true;
      this.userid = e.id;
      
    },

    removeSub(e){
      var that = this;
      delManage({id:that.userid,type:'3-4'},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('注销成功！');
          that.resetSub();
          that.removeType = false;
        } else {
          that.$message(data.msg);
        }
      });
    },

    removeHide(){
      this.userid = '';
      this.removeType = false;
    },

    authorityShow(e){
      var that = this;
      this.userid = e.id;
      getManageAuthority({id:e.id,type:'3-3'},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.authorityType=true;
          data.data.authority.forEach(function(item,index){
            that.authorityList.forEach(function(ele,num){
              ele.children.forEach(function(i,k){
                if(item == i.id){
                  i.disabled = false;
                }
              })
            })
          });

          data.data.my_authority.forEach(function(item,index){
            that.authorityList.forEach(function(ele,num){
              ele.children.forEach(function(i,k){
                if(item == i.id && !i.disabled){
                  i.check = true;
                };
              })
            })
          });
          
        } else {
          that.$message(data.msg);
        }
      });
    },


    authoritySub(){
      var that = this;
      var list = [];
      that.authorityList.forEach(function(ele,num){
        ele.children.forEach(function(i,k){
          if(i.check&&!i.disabled){
            list.push(i.id)
          }
        })
      });
      var obj = {
        id:that.userid,
        authority:list
      }
      setManageAuthority(obj,that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('修改成功！');
          that.resetSub();
          that.authorityType=false;
        } else {
          that.$message(data.msg);
        }
      });
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 9 );
}

.organiza-txt{
  height: calc(100% - 120px);
}

.authorityBox .contv{
  height: 80%;
}

.authorityBox .list{
  font-size: 0;
  text-align: left;
  height: calc( 100% - 100px );
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  padding: 0 20px;
}

.authorityBox .list .first{
  margin-bottom: 20px;
}

.authorityBox .list .first-title{
  font-size: 16px;
  color: #457AFF;
  line-height: 30px;
  height: 30px;
}

.authorityBox .list .second {
  margin-top: 12px;
}

.authorityBox .list .second-title {
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
}

.authorityBox .list .second-title label{
}

.authorityBox .list .second-title label input{
  widows: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: top;
}

.authorityBox .list .second-title p{
  font-size: 16px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
}

.authorityBox .list .second-title.noPointer p{
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/admin/index.vue